/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  PartnerStructuredColumnDto,
  PartnerStructuredColumnToggleDto,
  StructuredColumnRegistryEntryDto,
  StructuredColumnsControllerGetPartnerColumnsParams
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns the static code-defined registry of work_orders columns that can be shown in the Project Planner. Admin-only — partners read their merged view via /structured-columns/partner.
 * @summary List the Structured Columns registry
 */
export type structuredColumnsControllerListRegistryResponse200 = {
  data: StructuredColumnRegistryEntryDto[]
  status: 200
}

export type structuredColumnsControllerListRegistryResponse401 = {
  data: void
  status: 401
}

export type structuredColumnsControllerListRegistryResponse403 = {
  data: void
  status: 403
}
    
export type structuredColumnsControllerListRegistryResponseSuccess = (structuredColumnsControllerListRegistryResponse200) & {
  headers: Headers;
};
export type structuredColumnsControllerListRegistryResponseError = (structuredColumnsControllerListRegistryResponse401 | structuredColumnsControllerListRegistryResponse403) & {
  headers: Headers;
};

export type structuredColumnsControllerListRegistryResponse = (structuredColumnsControllerListRegistryResponseSuccess | structuredColumnsControllerListRegistryResponseError)

export const getStructuredColumnsControllerListRegistryUrl = () => {


  

  return `/structured-columns`
}

export const structuredColumnsControllerListRegistry = async ( options?: RequestInit): Promise<structuredColumnsControllerListRegistryResponse> => {
  
  return customFetch<structuredColumnsControllerListRegistryResponse>(getStructuredColumnsControllerListRegistryUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStructuredColumnsControllerListRegistryQueryKey = () => {
    return [
    `/structured-columns`
    ] as const;
    }

    
export const getStructuredColumnsControllerListRegistryQueryOptions = <TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStructuredColumnsControllerListRegistryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>> = ({ signal }) => structuredColumnsControllerListRegistry({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StructuredColumnsControllerListRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>>
export type StructuredColumnsControllerListRegistryQueryError = void


export function useStructuredColumnsControllerListRegistry<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>,
          TError,
          Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerListRegistry<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>,
          TError,
          Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerListRegistry<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the Structured Columns registry
 */

export function useStructuredColumnsControllerListRegistry<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStructuredColumnsControllerListRegistryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List the Structured Columns registry
 */
export const prefetchStructuredColumnsControllerListRegistryQuery = async <TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getStructuredColumnsControllerListRegistryQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getStructuredColumnsControllerListRegistrySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStructuredColumnsControllerListRegistryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>> = ({ signal }) => structuredColumnsControllerListRegistry({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StructuredColumnsControllerListRegistrySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>>
export type StructuredColumnsControllerListRegistrySuspenseQueryError = void


export function useStructuredColumnsControllerListRegistrySuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerListRegistrySuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerListRegistrySuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the Structured Columns registry
 */

export function useStructuredColumnsControllerListRegistrySuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerListRegistry>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStructuredColumnsControllerListRegistrySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the registry of Structured Columns with the partner's per-column enablement applied. Always-on columns are returned with is_enabled=true regardless of any junction row. By default only enabled columns are returned (used by the planner); pass include_inactive=true to receive disabled rows too (used by the partner config page). Scoped to the caller's own partner.
 * @summary Get a partner's Structured Columns merged with the registry
 */
export type structuredColumnsControllerGetPartnerColumnsResponse200 = {
  data: PartnerStructuredColumnDto[]
  status: 200
}

export type structuredColumnsControllerGetPartnerColumnsResponse401 = {
  data: void
  status: 401
}

export type structuredColumnsControllerGetPartnerColumnsResponse403 = {
  data: void
  status: 403
}
    
export type structuredColumnsControllerGetPartnerColumnsResponseSuccess = (structuredColumnsControllerGetPartnerColumnsResponse200) & {
  headers: Headers;
};
export type structuredColumnsControllerGetPartnerColumnsResponseError = (structuredColumnsControllerGetPartnerColumnsResponse401 | structuredColumnsControllerGetPartnerColumnsResponse403) & {
  headers: Headers;
};

export type structuredColumnsControllerGetPartnerColumnsResponse = (structuredColumnsControllerGetPartnerColumnsResponseSuccess | structuredColumnsControllerGetPartnerColumnsResponseError)

export const getStructuredColumnsControllerGetPartnerColumnsUrl = (params: StructuredColumnsControllerGetPartnerColumnsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/structured-columns/partner?${stringifiedParams}` : `/structured-columns/partner`
}

export const structuredColumnsControllerGetPartnerColumns = async (params: StructuredColumnsControllerGetPartnerColumnsParams, options?: RequestInit): Promise<structuredColumnsControllerGetPartnerColumnsResponse> => {
  
  return customFetch<structuredColumnsControllerGetPartnerColumnsResponse>(getStructuredColumnsControllerGetPartnerColumnsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getStructuredColumnsControllerGetPartnerColumnsQueryKey = (params?: StructuredColumnsControllerGetPartnerColumnsParams,) => {
    return [
    `/structured-columns/partner`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStructuredColumnsControllerGetPartnerColumnsQueryOptions = <TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStructuredColumnsControllerGetPartnerColumnsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>> = ({ signal }) => structuredColumnsControllerGetPartnerColumns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StructuredColumnsControllerGetPartnerColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>>
export type StructuredColumnsControllerGetPartnerColumnsQueryError = void


export function useStructuredColumnsControllerGetPartnerColumns<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>,
          TError,
          Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerGetPartnerColumns<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>,
          TError,
          Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerGetPartnerColumns<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner's Structured Columns merged with the registry
 */

export function useStructuredColumnsControllerGetPartnerColumns<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStructuredColumnsControllerGetPartnerColumnsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a partner's Structured Columns merged with the registry
 */
export const prefetchStructuredColumnsControllerGetPartnerColumnsQuery = async <TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 queryClient: QueryClient, params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getStructuredColumnsControllerGetPartnerColumnsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getStructuredColumnsControllerGetPartnerColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStructuredColumnsControllerGetPartnerColumnsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>> = ({ signal }) => structuredColumnsControllerGetPartnerColumns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StructuredColumnsControllerGetPartnerColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>>
export type StructuredColumnsControllerGetPartnerColumnsSuspenseQueryError = void


export function useStructuredColumnsControllerGetPartnerColumnsSuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerGetPartnerColumnsSuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStructuredColumnsControllerGetPartnerColumnsSuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner's Structured Columns merged with the registry
 */

export function useStructuredColumnsControllerGetPartnerColumnsSuspense<TData = Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError = void>(
 params: StructuredColumnsControllerGetPartnerColumnsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof structuredColumnsControllerGetPartnerColumns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStructuredColumnsControllerGetPartnerColumnsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upserts the partner_structured_columns junction row. Scoped to the caller's own partner. Always-on columns reject this call.
 * @summary Toggle a Structured Column for a partner
 */
export type structuredColumnsControllerTogglePartnerColumnResponse201 = {
  data: PartnerStructuredColumnToggleDto
  status: 201
}

export type structuredColumnsControllerTogglePartnerColumnResponse400 = {
  data: void
  status: 400
}

export type structuredColumnsControllerTogglePartnerColumnResponse401 = {
  data: void
  status: 401
}

export type structuredColumnsControllerTogglePartnerColumnResponse403 = {
  data: void
  status: 403
}
    
export type structuredColumnsControllerTogglePartnerColumnResponseSuccess = (structuredColumnsControllerTogglePartnerColumnResponse201) & {
  headers: Headers;
};
export type structuredColumnsControllerTogglePartnerColumnResponseError = (structuredColumnsControllerTogglePartnerColumnResponse400 | structuredColumnsControllerTogglePartnerColumnResponse401 | structuredColumnsControllerTogglePartnerColumnResponse403) & {
  headers: Headers;
};

export type structuredColumnsControllerTogglePartnerColumnResponse = (structuredColumnsControllerTogglePartnerColumnResponseSuccess | structuredColumnsControllerTogglePartnerColumnResponseError)

export const getStructuredColumnsControllerTogglePartnerColumnUrl = () => {


  

  return `/structured-columns/partner`
}

export const structuredColumnsControllerTogglePartnerColumn = async (partnerStructuredColumnToggleDto: PartnerStructuredColumnToggleDto, options?: RequestInit): Promise<structuredColumnsControllerTogglePartnerColumnResponse> => {
  
  return customFetch<structuredColumnsControllerTogglePartnerColumnResponse>(getStructuredColumnsControllerTogglePartnerColumnUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partnerStructuredColumnToggleDto,)
  }
);}




export const getStructuredColumnsControllerTogglePartnerColumnMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>, TError,{data: PartnerStructuredColumnToggleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>, TError,{data: PartnerStructuredColumnToggleDto}, TContext> => {

const mutationKey = ['structuredColumnsControllerTogglePartnerColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>, {data: PartnerStructuredColumnToggleDto}> = (props) => {
          const {data} = props ?? {};

          return  structuredColumnsControllerTogglePartnerColumn(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StructuredColumnsControllerTogglePartnerColumnMutationResult = NonNullable<Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>>
    export type StructuredColumnsControllerTogglePartnerColumnMutationBody = PartnerStructuredColumnToggleDto
    export type StructuredColumnsControllerTogglePartnerColumnMutationError = void

    /**
 * @summary Toggle a Structured Column for a partner
 */
export const useStructuredColumnsControllerTogglePartnerColumn = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>, TError,{data: PartnerStructuredColumnToggleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof structuredColumnsControllerTogglePartnerColumn>>,
        TError,
        {data: PartnerStructuredColumnToggleDto},
        TContext
      > => {

      const mutationOptions = getStructuredColumnsControllerTogglePartnerColumnMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    